module.exports = __webpack_public_path__ + "img/2_1.d8589e08.jpg";